<template>
  <div>
    <div class="jobSearch-bottom_img" style="position: relative;">
      <img style="width:100%;height:50vh" v-if="jobSearchlist.position1.length>0" :src="jobSearchlist.position1[0].thumb" />
      <p v-if="false" style="position: absolute;
              color: #fff;
              bottom: 10vh;
              font-size: 6vh;
              left: 12%;
              border-bottom: 2px solid #ccc;
              font-weight: 600;">{{ jobSearchlist.position1[0].title }}</p>
    </div>

    <section class="jobs-area section-padding3" style="margin-top:50px">
      <div class="container">
        <div class="row" v-if="jobSearchlist.position1.length>0">
          <div class="col-lg-12">
            <div class="jobs-title">
              <h2>{{ jobSearchlist.position1[0].title }}</h2>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="jobs-tab tab-item">
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <!-- :style="{color:(index==0?'#ff9902':'black')}" -->
                <li class="nav-item" v-for="(item, index) in tabList" :key="index">
                  <a class="nav-link " data-toggle="tab" v-on:click="switchTab(index, item)"
                    :style="getStyle(index)">{{ item.name }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade show active" v-if="index == 0">
                <div class="feature-area">
                  <div class="container">
                    <div class="row">
                      <div class="col-lg-6">
                        <div v-if="jobSearchlist.position2.length>0" class="single-feature mb-4 mb-lg-0" @click="detailClick(jobSearchlist.position2[0].id)">
                          <img width="100%" height="50%" src="static/assets/images/banner-bg.jpg" />
                          <h2 class="no-margin">{{ jobSearchlist.position2[0].created_at }}</h2>
                          <!-- <h4>{{ year }}</h4> -->
                          <h4 style="margin-top: 15px">{{ jobSearchlist.position2[0].title }}</h4>
                          <p class="py-1 no-margin">{{ jobSearchlist.position2[0].brief }}</p>
                          <a href="#" class="secondary-btn">立即了解<span class="flaticon-next"></span></a>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="single-feature mb-4 mb-lg-3" v-for="(item, index) in position3" :key="index" @click="detailClick(item.id)">
                          <div class="row">
                            <div class="col-lg-3" style="display: flex">
                              <img width="100%" height="50%" :src="item.thumb" style="align-self:center" />
                            </div>
                            <div class="col-lg-9">
                              <h2 class="no-margin">{{ item.created_at }}</h2>
                              <h4 style="margin-top: 15px">{{ item.title }}</h4>
                              <p class="py-1 no-margin">{{ item.brief }}</p>
                              <a href="#" class="secondary-btn btn-position-right">立即了解<span
                                  class="flaticon-next"></span></a>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade show active" v-if="index == 1">
                <div class="feature-area">
                  <div class="container">
                    <div class="row">
                      <div v-if="jobSearchlist.position2.length>0" class="col-lg-6" @click="detailClick(jobSearchlist.position2[0].id)">
                        <div class="single-feature mb-4 mb-lg-0">
                          <img width="100%" height="50%" src="static/assets/images/banner-bg.jpg" />
                          <h2 class="no-margin">{{ jobSearchlist.position2[0].created_at }}</h2>
                          <h4 style="margin-top: 15px">{{ jobSearchlist.position2[0].title }}</h4>
                          <p class="py-1 no-margin">{{ jobSearchlist.position2[0].brief }}</p>
                          <a href="#" class="secondary-btn">立即了解<span class="flaticon-next"></span></a>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="single-feature mb-4 mb-lg-3" v-for="(item, index) in position3" :key="index" @click="detailClick(item.id)">
                          <div class="row">
                            <div class="col-lg-3" style="display: flex">
                              <img width="100%" height="50%" :src="item.thumb" style="align-self:center" />
                            </div>
                            <div class="col-lg-9">
                              <h2 class="no-margin">{{ item.created_at }}</h2>
                              <h4 style="margin-top: 15px">{{ item.title }}</h4>
                              <p class="py-1 no-margin">{{ item.brief }}</p>
                              <a href="#" class="secondary-btn btn-position-right">立即了解<span
                                  class="flaticon-next"></span></a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade show active" v-if="index == 2">
                <div class="feature-area">
                  <div class="container">
                    <div class="row">
                      <div class="col-lg-6">
                        <div v-if="jobSearchlist.position2.length>0" class="single-feature mb-4 mb-lg-0" @click="detailClick(jobSearchlist.position2[0].id)">
                          <img width="100%" height="50%" src="static/assets/images/banner-bg.jpg" />
                          <h2 class="no-margin">{{ jobSearchlist.position2[0].created_at }}</h2>
                          <h4 style="margin-top: 15px">{{ jobSearchlist.position2[0].title }}</h4>
                          <p class="py-1 no-margin">{{ jobSearchlist.position2[0].brief }}</p>
                          <a href="#" class="secondary-btn">立即了解<span class="flaticon-next"></span></a>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="single-feature mb-4 mb-lg-3" v-for="(item, index) in position3" :key="index" @click="detailClick(item.id)">
                          <div class="row">
                            <div class="col-lg-3" style="display: flex">
                              <img width="100%" height="50%" :src="item.thumb" style="align-self:center" />
                            </div>
                            <div class="col-lg-9">
                              <h2 class="no-margin">{{ item.created_at }}</h2>
                              <h4 style="margin-top: 15px">{{ item.title }}</h4>
                              <p class="py-1 no-margin">{{ item.brief }}</p>
                              <a href="#" class="secondary-btn btn-position-right">立即了解<span
                                  class="flaticon-next"></span></a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade show active" v-if="index == 3">
                <div class="feature-area">
                  <div class="container">
                    <div class="row">
                      <div class="col-lg-6">
                        <div v-if="jobSearchlist.position2.length>0" class="single-feature mb-4 mb-lg-0" @click="detailClick(jobSearchlist.position2[0].id)">
                          <img width="100%" height="50%" src="static/assets/images/banner-bg.jpg" />
                          <h2 class="no-margin">{{ jobSearchlist.position2[0].created_at }}</h2>
                          <h4 style="margin-top: 15px">{{ jobSearchlist.position2[0].title }}</h4>
                          <p class="py-1 no-margin">{{ jobSearchlist.position2[0].brief }}</p>
                          <a href="#" class="secondary-btn">立即了解<span class="flaticon-next"></span></a>
                        </div>
                      </div>
                      <div class="col-lg-6">
                        <div class="single-feature mb-4 mb-lg-3" v-for="(item, index) in position3" :key="index" @click="detailClick(item.id)">
                          <div class="row">
                            <div class="col-lg-3" style="display: flex">
                              <img width="100%" height="50%" :src="item.thumb" style="align-self:center" />
                            </div>
                            <div class="col-lg-9">
                              <h2 class="no-margin">{{ item.created_at }}</h2>
                              <h4 style="margin-top: 15px">{{ item.title }}</h4>
                              <p class="py-1 no-margin">{{ item.brief }}</p>
                              <a href="#" class="secondary-btn btn-position-right">立即了解<span
                                  class="flaticon-next"></span></a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade show active" v-if="index == 4">
                <div class="single-job mb-4 d-lg-flex justify-content-between">
                  <div class="job-text">
                    <h4>测试v-if</h4>
                    <ul class="mt-4">
                      <li class="mb-3">
                        <h5><i class="fa fa-map-marker"></i> new yourk, USA</h5>
                      </li>
                      <li class="mb-3">
                        <h5><i class="fa fa-pie-chart"></i>
                          Applied Chemistry & Chemical Engineering / Chemistry</h5>
                      </li>
                      <li>
                        <h5><i class="fa fa-clock-o"></i> Deadline Deadline: Dec 11, 2018</h5>
                      </li>
                    </ul>
                  </div>
                  <div class="job-img align-self-center">
                    <img src="static/assets/images/job4.png" alt="job">
                  </div>
                  <div class="job-btn align-self-center">
                    <a href="#" class="third-btn job-btn4">full time</a>
                    <a href="#" class="third-btn">apply</a>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="mt-5 text-right">
          <el-pagination  @current-change="handleCurrentChange"
            :current-page="currentPage4" :page-size="4" :total="Number(total)" style="white-space: pre-line">
          </el-pagination>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import { us, options, pageList } from '@/api/index'
import axios from "axios";

export default {
  data() {
    return {
      currentPage4: 0,
      index: 0,
      total: 0,
      searchPanel: {
        type: 1,
        page: 1,
        page_size: 4,
        position: 3,
        id: ''
      },
      jobSearchlist: {
        position1: [],
        position2: [],
        position3: [],
        position4: [],

      },
      position3: [],
      tabList: [],

    }
  },
  mounted() {
    this.searchPanel.id = this.$route.query.id
    this.getus(this.$route.query.id);
    this.getOptions();
    this.getPageList()
  },
  methods: {
    switchTab(index, item) {
      let value = JSON.parse(item.setting);
      this.searchPanel.type = value.value;
      this.searchPanel.page = 1;
      this.index = index;
      this.getPageList()
    },
    detailClick(id){
      console.log('2')
      this.$router.push({
        path: '/detail',
        query:{
          id:id
        }
      })
    },
    getStyle(index) {
      if (this.index === index) {
        return {
          color: '#ff9902'
        }
      }

    },
    handleCurrentChange(page) {
      this.searchPanel.page = page;
      this.getPageList()
     },

    getPageList() {
      axios.get('http://cms.saveus.cn/api/ttg/page/list',{
        params:this.searchPanel
      }).then(res=>{
        this.position3 = res.data.data.list;
         this.total = res.data.data.total;
      })
    },
    getOptions() {
      let id = '244';
       axios.get('http://cms.saveus.cn//api/ttg/options?id='+id).then(res=>{
        this.tabList = res.data.data;
       })
    },
    getus(id) {
       axios.get('http://cms.saveus.cn/api/ttg/page?id='+id).then(res=>{
         let list = res.data.data;

         for (let index = 0; index < list.length; index++) {
           if (list[index].position == 1) {
             this.jobSearchlist.position1.push(list[index])
           } else if (list[index].position == 2) {
             this.jobSearchlist.position2.push(list[index])
           } else if (list[index].position == 3) {
             list[index].status1 = false
             this.jobSearchlist.position3.push(list[index])
           } else if (list[index].position == 4) {
             this.jobSearchlist.position4.push(list[index])
           }
         }
       })
    },
  },

}
</script>
<style scoped>
.jobSearch-bottom_img {
  height: 50vh;
  /* background:url(/static/assets/images/news.png); */
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

@media (min-width: 280px) {
  .jinglingtu {
    display: none;
  }

  .no-margin {
    margin: 0
  }

  /* .none{
    display: none;
  } */
  .b-a-box {
    width: 100%;
    height: 50vh;
  }

  .b-a-box>.b-astyle {
    height: 50vh;
    background: url(/static/assets/images/zhuangshi.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .top_box {
    width: 100%;
    height: 100vh;
  }

  .top_box>.bg-name {
    height: 100vh !important;
    width: 100%;
    margin: 0 auto;
    top: 100px;
    background: #fff;
    box-shadow: 10px 10px 10px 10px rgba(0.5, 0.5, 0.5, 0.5);
    -moz-box-shadow: 10px 10px 10px 10px rgba(0.5, 0.5, 0.5, 0.5);
    -webkit-box-shadow: 10px 10px 10px 10px rgba(0.5, 0.5, 0.5, 0.5);
  }

  .top_box>.bg-name>p {
    padding: 1vh;
    font-size: 2vh;
  }

  .top_box>.bg-name>img {
    display: none;
  }

  .top_box>.bg-name>h3 {
    padding: 1vh;
    font-size: 3vh;
    font-weight: 600;
    text-align: center;
  }
}

@media (min-width: 1200px) {
  .b-a-box {
    width: 100%;
    height: 100vh;
  }

  .b-a-box>.b-astyle {
    height: 100vh;
    background: url(/static/assets/images/zhuangshi.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }

  .box {
    border: 1px solid;
    height: 100%;
    width: 100%;
    position: absolute;
  }

  .top_box {
    width: 100%;
    height: 100vh;
    position: relative;

  }

  .top_box>.bg {
    height: 50%;
    width: 50%;
    margin: 0 auto;
    background: url(/static/assets/images/zhuangshi.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: right -58px bottom 65px;
  }

  .top_box>.bg-name {
    height: 60vh !important;
    width: 50%;
    margin: 0 auto;
    position: absolute;
    top: 100px;
    background: #fff;
    border-radius: 10px;
    margin-left: 25%;
    box-shadow: 10px 10px 10px 10px rgba(0.5, 0.5, 0.5, 0.5);
    -moz-box-shadow: 10px 10px 10px 10px rgba(0.5, 0.5, 0.5, 0.5);
    -webkit-box-shadow: 10px 10px 10px 10px rgba(0.5, 0.5, 0.5, 0.5);
  }

  .bg-name>img {
    width: 50%;
    margin: 0 auto;
    position: absolute;
    top: -50px;
    left: 25%;
    display: block !important;
  }

  .bg-name>h3 {
    position: absolute;
    top: -66px !important;
    left: 43% !important;
  }

  .color {
    color: black;
  }
}
</style>



// WEBPACK FOOTER //
// JobSearch.vue?63506183